<template>
  <b-row>
    <b-col cols="12">
      <b-table
        id="reports-table"
        responsive="sm"
        hover
        :items="reports"
        :fields="fields"
        stacked="md"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        :busy="isLoading"
        :perPage="perPage"
        :currentPage="currentPage"
        show-empty
        empty-text="Currently there are no reports."
      >
        <template v-slot:cell(title)="row">
          <a href="#" @click.prevent="row.toggleDetails">{{ row.item.title }}</a>
        </template>
        <template v-slot:cell(type)="{ item }">{{ reportType[item.type] }}</template>
        <template v-slot:cell(status)="{ item }">
          <b-badge :variant="showStatus(item.status).variant">{{ showStatus(item.status).response }}</b-badge>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner small class="align-middle mr-2"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(actions)="row">
          <b-button
            v-if="row.detailsShowing"
            size="sm"
            @click="row.toggleDetails"
            variant="primary"
          >
            <i class="fas fa-eye-slash"></i>
            Hide details
          </b-button>
          <b-button v-else size="sm" @click="row.toggleDetails" variant="outline-primary">
            <i class="fas fa-eye"></i>
            Show details
          </b-button>
        </template>

        <template v-slot:empty="scope">
          <b-alert variant="warning" show>{{ scope.emptyText }}</b-alert>
        </template>
        <template v-slot:row-details="{ item }">
          <b-card>
            <b-form-group
              label="Document"
              label-cols-lg="3"
              label-cols-xl="2"
              label-align-lg="right"
            >
              <b-button @click.prevent="download(item)" variant="link">
                <b-icon icon="download" class="mr-1"></b-icon>
                {{ item.filename }}
              </b-button>
            </b-form-group>
            <b-form-group
              label="Notes"
              label-cols-lg="3"
              label-cols-xl="2"
              label-align-lg="right"
            >
              <div style="padding:0.5rem" v-html="item.notes"></div>
            </b-form-group>
            <b-form-group label="Actions" label-cols-lg="3" label-cols-xl="2" label-align-lg="right">
              <b-button variant="danger" size="sm" @click.prevent="deleteReport(item)">
                <b-icon icon="trash" class="mr-1"></b-icon>Delete
              </b-button>
            </b-form-group>
          </b-card>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-number
        last-number
        align="center"
        aria-controls="projects-table"
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import config from "@/config";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      URL: config.API_URL,
      sortBy: "created_at",
      stackedBr: "md",
      sortDesc: true,
      isLoading: true,
      currentPage: 1,
      perPage: 20,
      fields: [
        { key: "title", label: "Title", sortable: true },
        { key: "type", label: "Type", sortable: false },
        { key: "status", label: "Status", sortable: false },
        {
          key: "created_at",
          label: "Date",
          sortable: true,
          thStyle: { width: "190px" }
        },
        { key: "actions", label: "Details", thStyle: { width: "160px" } }
      ],
      reportType: config.report_type,
      reportStatus: config.report_status,
      statusColor: config.report_status_color
    };
  },
  computed: {
    ...mapGetters({
      reports: "report/allReports",
      rows: "report/countReports"
    })
  },
  created() {
    this.getReports()
      .then()
      .catch(err => {
        console.log(err);
      })
      .then(() => {
        this.isLoading = false;
      });
  },
  methods: {
    ...mapActions({
      downloadReport: "report/download",
      getReports: "report/fetchAllReports",
      destroy: "report/destroyReport"
    }),
    download(report) {
      this.downloadReport(report)
        .then()
        .catch(err => {
          this.makeToast(
            "danger",
            "Error",
            "Document " + report.filename + " not found!"
          );
        });
    },
    deleteReport(report) {
      var response = confirm("Do you want to delete this report?");
      if (response) {
        this.destroy(report.id)
          .then(() => {
            this.makeToast(
              "success",
              "Report deleted!",
              "Report " + report.title + " has been deleted."
            );
          })
          .catch(err => {
            this.makeToast("danger", "Error!", "Error while deleting.");
          });
      }
    }
  }
};
</script>

<style>
</style>